import React from 'react';
export function VehicleModels() {
  const brands = ['BMW', 'Mercedes-Benz', 'Audi', 'Volkswagen', 'Ford', 'Toyota', 'Hyundai'];
  return <section className="py-16 bg-[#0a0a0f] border-t border-gray-800" data-id="element-228">
      <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-229">
        <h2 className="text-2xl font-bold text-white mb-8" data-id="element-230">
          Unterstützte Marken & Modelle
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto mb-10" data-id="element-231">
          Wir unterstützen bereits über 200 Modelle der führenden Hersteller.
          Unser System wird ständig erweitert.
        </p>

        <div className="flex flex-wrap justify-center gap-8 md:gap-12 opacity-50 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-232">
          {brands.map((brand, index) => <span key={index} className="text-xl md:text-2xl font-bold text-gray-300 hover:text-cyan-400 cursor-default" data-id="element-233">
              {brand}
            </span>)}
        </div>
      </div>
    </section>;
}